import React from 'react';

interface LocationSelectorProps {
  isDarkMode: boolean;
  selectedLocation: string;
  onLocationChange: (location: string) => void;
  locations: string[];
}

const LocationSelector: React.FC<LocationSelectorProps> = ({ 
  isDarkMode, 
  selectedLocation, 
  onLocationChange,
  locations 
}) => {
  return (
    <div className="location-selector">
      <select
        id="location-filter"
        value={selectedLocation}
        onChange={(e) => onLocationChange(e.target.value)}
        className={`location-dropdown ${isDarkMode ? 'dark' : ''}`}
        style={{
          padding: '6px 12px',
          borderRadius: '4px',
          border: `1px solid ${isDarkMode ? '#424242' : '#e0e0e0'}`,
          backgroundColor: isDarkMode ? '#2c2c2c' : '#ffffff',
          color: isDarkMode ? '#ffffff' : '#212121',
          fontSize: '14px',
          cursor: 'pointer',
          minWidth: '150px',
          outline: 'none',
        }}
      >
        <option value="all">Barcha joylar</option>
        {locations.map((location) => (
          <option key={location} value={location}>
            {location}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LocationSelector;
